import { useMutation } from "@apollo/client";
import { CreateAddressDocument } from "@/__generated__/graphql";

export const useCreateAddressMutation = () => {
  return useMutation(CreateAddressDocument);
};
